/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TotalSales
 */
export interface TotalSales {
    /**
     * 
     * @type {number}
     * @memberof TotalSales
     */
    year: number;
    /**
     * 
     * @type {number}
     * @memberof TotalSales
     */
    ordersAmount: number;
    /**
     * 
     * @type {number}
     * @memberof TotalSales
     */
    openOrdersAmount: number;
    /**
     * 
     * @type {number}
     * @memberof TotalSales
     */
    invoiceAmount: number;
    /**
     * 
     * @type {number}
     * @memberof TotalSales
     */
    creditNoteAmount: number;
    /**
     * 
     * @type {number}
     * @memberof TotalSales
     */
    canceledInvoiceAmount: number;
    /**
     * 
     * @type {number}
     * @memberof TotalSales
     */
    canceledOrdersAmount: number;
    /**
     * 
     * @type {number}
     * @memberof TotalSales
     */
    quota: number;
}

/**
 * Check if a given object implements the TotalSales interface.
 */
export function instanceOfTotalSales(value: object): value is TotalSales {
    if (!('year' in value) || value['year'] === undefined) return false;
    if (!('ordersAmount' in value) || value['ordersAmount'] === undefined) return false;
    if (!('openOrdersAmount' in value) || value['openOrdersAmount'] === undefined) return false;
    if (!('invoiceAmount' in value) || value['invoiceAmount'] === undefined) return false;
    if (!('creditNoteAmount' in value) || value['creditNoteAmount'] === undefined) return false;
    if (!('canceledInvoiceAmount' in value) || value['canceledInvoiceAmount'] === undefined) return false;
    if (!('canceledOrdersAmount' in value) || value['canceledOrdersAmount'] === undefined) return false;
    if (!('quota' in value) || value['quota'] === undefined) return false;
    return true;
}

export function TotalSalesFromJSON(json: any): TotalSales {
    return TotalSalesFromJSONTyped(json, false);
}

export function TotalSalesFromJSONTyped(json: any, ignoreDiscriminator: boolean): TotalSales {
    if (json == null) {
        return json;
    }
    return {
        
        'year': json['year'],
        'ordersAmount': json['ordersAmount'],
        'openOrdersAmount': json['openOrdersAmount'],
        'invoiceAmount': json['invoiceAmount'],
        'creditNoteAmount': json['creditNoteAmount'],
        'canceledInvoiceAmount': json['canceledInvoiceAmount'],
        'canceledOrdersAmount': json['canceledOrdersAmount'],
        'quota': json['quota'],
    };
}

export function TotalSalesToJSON(json: any): TotalSales {
    return TotalSalesToJSONTyped(json, false);
}

export function TotalSalesToJSONTyped(value?: TotalSales | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'year': value['year'],
        'ordersAmount': value['ordersAmount'],
        'openOrdersAmount': value['openOrdersAmount'],
        'invoiceAmount': value['invoiceAmount'],
        'creditNoteAmount': value['creditNoteAmount'],
        'canceledInvoiceAmount': value['canceledInvoiceAmount'],
        'canceledOrdersAmount': value['canceledOrdersAmount'],
        'quota': value['quota'],
    };
}

